/**
 * Formats a date as a long Russian date without the "г." suffix.
 * Example: `12 сентября 2026`
 */
export const formatLongDate = (date: Date | string | number): string =>
  new Date(date)
    .toLocaleDateString('ru-RU', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
    .replace(/\s*г\./, '');
